import {getIdentityTransition} from './identityTransition'

type AnalyticsJson =
  | null
  | boolean
  | number
  | string
  | AnalyticsJson[]
  | {[key: string]: AnalyticsJson}
type AnalyticsProperties = Record<string, AnalyticsJson>

type SyncAnalyticsIdentityParams = {
  prevDid: string | undefined
  currentDid: string | undefined
  hasPersistedIdentifiedDid?: boolean
  identifyTraits: AnalyticsProperties
  anonymousGlobalProperties: AnalyticsProperties
  identify: (did: string, traits: AnalyticsProperties) => void
  reset: () => void
  registerGlobalProperties: (properties: AnalyticsProperties) => void
  onIdentifySync?: (did: string) => void
  onResetSync?: () => void
  isInitialSync?: boolean
}

export function syncAnalyticsIdentity({
  prevDid,
  currentDid,
  hasPersistedIdentifiedDid = false,
  identifyTraits,
  anonymousGlobalProperties,
  identify,
  reset,
  registerGlobalProperties,
  onIdentifySync,
  onResetSync,
  isInitialSync = false,
}: SyncAnalyticsIdentityParams): string | undefined {
  // Migration safety: clear stale persisted identity when app boots logged out.
  if (isInitialSync && !currentDid && hasPersistedIdentifiedDid) {
    reset()
    registerGlobalProperties(anonymousGlobalProperties)
    onResetSync?.()
    return currentDid
  }

  const transition = getIdentityTransition(prevDid, currentDid)
  if (transition.action === 'identify') {
    identify(transition.did, identifyTraits)
    onIdentifySync?.(transition.did)
  } else if (transition.action === 'reset') {
    reset()
    registerGlobalProperties(anonymousGlobalProperties)
    onResetSync?.()
  }

  return currentDid
}
